module.exports = __webpack_public_path__ + "assets/IsoscelesTriangleAboutCircleDetailed.4c4ba1f25057b256899968fcd1941a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/IsoscelesTriangleAboutCircleDetailed.png
// module id = 527
// module chunks = 0